import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

export const routes: Routes = [
  {
    path: '',
    loadChildren: 'app/reestablecer-clave-solicitud/reestablecer-clave-solicitud.module#ReestablecerClaveSolicitudModule'
  },{
    path: '',
    loadChildren: 'app/reestablecer-clave-envio-datos/reestablecer-clave-envio-datos.module#ReestablecerClaveEnvioDatosModule'
  },
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts